export default "__VITE_ASSET__DBbUNyp9__"